export default {
    /*
      使用方式
      只允許整數  v-number
      允許小數，默認兩位 v-number.decimal
      指定小數位數  v-number.decimal.places="3"
      允許負數 v-number.negative
      允許負數和2位小數 v-number.decimal.negative
     */
    mounted(el, { modifiers }) {
        // 配置參數
        const allowDecimal = modifiers.decimal; // 是否允許小數
        const decimalPlaces = modifiers.places || 2; // 小數位數||默認兩位
        const allowNegative = modifiers.negative; // 是否允許負數

        const findInput = () => el.querySelector('input') || el;

        const handleInput = (e) => {
            const input = findInput();
            let value = input.value;
            let cursorPos = input.selectionStart;

            let filteredValue = value.replace(/[^0-9.-]/g, '');

            if (allowNegative) {
                filteredValue = filteredValue.replace(/(?!^)-/g, '');
            } else {
                filteredValue = filteredValue.replace(/-/g, '');
            }

            if (allowDecimal) {
                const parts = filteredValue.split('.');
                if (parts.length > 1) {
                    filteredValue = parts[0] + '.' + parts[1].slice(0, decimalPlaces);
                }
            } else {
                filteredValue = filteredValue.replace(/\./g, '');
            }

            if (value !== filteredValue) {
                input.value = filteredValue;
                const diff = filteredValue.length - value.length;
                cursorPos = Math.max(0, cursorPos + diff);
                input.setSelectionRange(cursorPos, cursorPos);
                input.dispatchEvent(new Event('input'));
            }
        };

        // 處理粘貼事件
        const handlePaste = (e) => {
            e.preventDefault();
            const text = (e.clipboardData || window.clipboardData).getData('text');
            const input = findInput();
            const cursorPos = input.selectionStart;
            document.execCommand('insertText', false, text.replace(/[^0-9.-]/g, ''));
            handleInput({ target: input });
        };

        setTimeout(() => {
            const input = findInput();
            handleInput({ target: input });
        });

        el._numericHandlers = {
            input: handleInput,
            paste: handlePaste
        };
        el.addEventListener('input', handleInput);
        el.addEventListener('paste', handlePaste);
    },

    unmounted(el) {
        if (el._numericHandlers) {
            Object.entries(el._numericHandlers).forEach(([event, handler]) => {
                el.removeEventListener(event, handler);
            });
        }
    }
}
